import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import OutcomeAlignments from '@instructure/outcomes-ui/es/containers/OutcomeAlignments';
import OutcomeCount from '@instructure/outcomes-ui/es/containers/OutcomeCount';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import CustomPropTypes from '../../../../../common/util/CustomPropTypes';
import componentForItem from '../../../../util/componentForItem';
import { liveRegion, COMPONENT_EDIT, FormFieldGroup } from '@instructure/quiz-common';
import t from '@instructure/quiz-i18n/es/format-message';
import { propsForInteractionEdit } from '../../../../util/interactionTypePropsHelper';
import { toErrors } from '../../../../util/instUIMessages';
export var ItemEdit = /*#__PURE__*/function (_Component) {
  function ItemEdit() {
    var _this;
    _classCallCheck(this, ItemEdit);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ItemEdit, [].concat(args));
    _defineProperty(_this, "onOutcomeAlignmentSetChange", function (outcomeAlignmentSet) {
      var item = _this.props.entry;
      if (item.outcomeAlignmentSetGuid !== outcomeAlignmentSet.guid) {
        return _this.props.changeOutcomeAlignmentSetGuid(item.id, outcomeAlignmentSet.guid);
      }
      return null;
    });
    _defineProperty(_this, "onModalOpen", function () {
      _this.props.occludeQuizEntries(true);
    });
    _defineProperty(_this, "onModalClose", function () {
      _this.props.occludeQuizEntries(false);
    });
    _defineProperty(_this, "getError", function (field) {
      if (_this.props.errorsAreShowing) {
        var errors = _this.props.workingItem.getErrors().toJS();
        return toErrors(errors[field] || []);
      }
    });
    return _this;
  }
  _inherits(ItemEdit, _Component);
  return _createClass(ItemEdit, [{
    key: "additionalEditOptions",
    value: function additionalEditOptions() {
      var _this$props = this.props,
        guid = _this$props.guid,
        workingItem = _this$props.workingItem;
      var itemId = guid || workingItem.get('id');
      var outcomeAlignmentSetGuid = workingItem.get('outcomeAlignmentSetGuid');
      var launchContexts = [];
      var rootAccountName = this.props.scope.root_account_name;
      var launchContextUuid = this.props.scope.launch_context_uuid;
      var launchContextTitle = this.props.scope.title;
      // If editing within a quiz, there is no account launch context
      if (rootAccountName) {
        launchContexts.push({
          uuid: this.props.rootAccountUuid,
          name: rootAccountName
        });

        // Add if it is a course or sub-account launch context
        if (launchContextUuid && launchContextUuid !== this.props.rootAccountUuid) {
          launchContexts.push({
            uuid: launchContextUuid,
            name: launchContextTitle
          });
        }
      }
      var options = [];
      if (this.props.outcomesEndpoint) {
        options.push({
          key: 'outcomes',
          title: /*#__PURE__*/React.createElement("span", null, t('Align to Outcomes'), /*#__PURE__*/React.createElement(OutcomeCount, Object.assign({
            alignmentSetId: outcomeAlignmentSetGuid,
            artifactType: "quizEntry",
            artifactId: itemId,
            contextUuid: this.props.contextUuid
            // Both components need to be aware of the launch contexts
          }, launchContexts.length > 0 && {
            launchContexts: launchContexts
          }, {
            host: this.props.outcomesEndpoint,
            jwt: this.props.outcomesToken,
            screenreaderNotification: this.props.screenreaderNotification,
            liveRegion: liveRegion
          }))),
          component: /*#__PURE__*/React.createElement(OutcomeAlignments, Object.assign({
            artifactType: "quizEntry",
            artifactId: itemId,
            alignmentSetId: outcomeAlignmentSetGuid,
            contextUuid: this.props.contextUuid
          }, launchContexts.length > 0 && {
            launchContexts: launchContexts
          }, {
            emptySetHeading: t('Align Institution outcomes to this question.'),
            host: this.props.outcomesEndpoint,
            jwt: this.props.outcomesToken,
            onModalOpen: this.onModalOpen,
            onModalClose: this.onModalClose,
            onUpdate: this.onOutcomeAlignmentSetChange,
            screenreaderNotification: this.props.screenreaderNotification,
            liveRegion: liveRegion
          }))
        });
      }
      if (this.props.additionalOptions) {
        return options.concat(this.props.additionalOptions);
      }
      return options;
    }
  }, {
    key: "render",
    value: function render() {
      var item = this.props.entry;
      var interactionType = item.getInteractionType().slug;
      var Interaction = componentForItem(interactionType, COMPONENT_EDIT);
      var propsForInteraction = propsForInteractionEdit(this.props, this.additionalEditOptions());
      return /*#__PURE__*/React.createElement(FormFieldGroup, {
        messages: this.getError('onSelf'),
        description: /*#__PURE__*/React.createElement(ScreenReaderContent, null, t('Edit question:')),
        name: "edit_item_".concat(this.props.guid)
      }, /*#__PURE__*/React.createElement(Interaction, Object.assign({}, propsForInteraction, {
        itemId: this.props.guid
      })));
    }
  }]);
}(Component);
_defineProperty(ItemEdit, "propTypes", {
  additionalOptions: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    component: PropTypes.node.isRequired
  })),
  answerFeedbackEnabled: PropTypes.bool,
  appContainer: CustomPropTypes.selectors.isRequired,
  changeOutcomeAlignmentSetGuid: PropTypes.func.isRequired,
  entry: ImmutablePropTypes.record.isRequired,
  fitbCommonWordbankEnabled: PropTypes.bool,
  guid: PropTypes.string.isRequired,
  occludeQuizEntries: PropTypes.func.isRequired,
  contextUuid: PropTypes.string,
  outcomesEndpoint: PropTypes.string,
  outcomesToken: PropTypes.string,
  workingItem: ImmutablePropTypes.record.isRequired,
  // required by propsForInteractionEdit
  addError: PropTypes.func.isRequired,
  changeItemState: PropTypes.func.isRequired,
  errorsAreShowing: PropTypes.bool,
  handleQuizEntryPointsChange: PropTypes.func.isRequired,
  interactionFileUpload: PropTypes.func.isRequired,
  oneQuestionAtATime: PropTypes.bool.isRequired,
  parentId: PropTypes.string.isRequired,
  parentType: PropTypes.string.isRequired,
  partialDeepScoringEnabled: PropTypes.bool,
  partialScoringEnabled: PropTypes.bool,
  quizId: PropTypes.string,
  screenreaderNotification: PropTypes.func.isRequired,
  setOneQuestionAtATime: PropTypes.func.isRequired,
  setUploadStatus: PropTypes.func.isRequired,
  initialFocusId: PropTypes.string,
  clearValidationErrorsFromApi: PropTypes.func.isRequired,
  validationErrorsFromApi: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    text: PropTypes.string
  }))),
  scope: PropTypes.shape({
    type: PropTypes.string,
    uuid: PropTypes.string,
    title: PropTypes.string,
    launch_context_uuid: PropTypes.string,
    root_account_name: PropTypes.string
  }),
  rootAccountUuid: PropTypes.string
});
_defineProperty(ItemEdit, "defaultProps", {
  additionalOptions: [],
  answerFeedbackEnabled: false,
  contextUuid: null,
  fitbCommonWordbankEnabled: false,
  errorsAreShowing: false,
  outcomesEndpoint: null,
  outcomesToken: null,
  partialDeepScoringEnabled: false,
  partialScoringEnabled: false,
  quizId: null,
  initialFocusId: null,
  validationErrorsFromApi: {},
  scope: {},
  rootAccountUuid: null
});
export default ItemEdit;